@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackGuideNav {
  position: sticky;
  top: 0px;
  padding: 0px 25px 0;
  width: calc(100% - 50px);
  overflow: auto;

  .scroll {
    height: 100%;
  }

  .guides {
    color: var(--grey-text-dark);
    font-size: 14px;
    margin-bottom: 30px;
    margin-top: 40px;
  }

  .categories {
    .category {
      margin-bottom: 35px;

      &.collapsed {
        .posts {
          display: none;
        }

        .icon {
          @include icons.icoImportant("black-plus");
        }
      }

      .head {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        gap: 12px;

        .collapse {
          height: 22px;
          width: 22px;
          background: var(--grey-sur);
          flex: 0 0 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          cursor: pointer;

          &:hover {
            background: var(--grey-sur-hover);
          }

          .icon {
            height: 12px;
            width: 12px;

            @include icons.ico("black-less");
          }
        }

        .title {
          font-size: 19px;
          color: var(--black);

          @include texts.font("semi-bold");
        }
      }

      .posts {
        color: var(--black);
        margin: 0;
        padding: 0;
        list-style: none;

        li {
          font-size: 16px;
          cursor: pointer;

          &.selected {
            color: var(--web-blue);

            @include texts.font("semi-bold");

            .badge {
              width: 8px;
              background: var(--web-blue) !important;
            }
          }

          &:hover {
            .badge {
              width: 8px;
              background: var(--black);
            }
          }

          a {
            color: black;
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 12px 0px;
            border-bottom: 1px solid var(--grey-sur);
          }

          .badge {
            height: 20px;
            width: 0;
            border-radius: 2px;
            transition: 0.2s;
          }
        }
      }
    }
  }

}